// extracted by mini-css-extract-plugin
export default {"customValue":"CustomValue_customValue__zE5Ds"};